import { GETv1HistoryBySymbol } from '@/api/quotes';
import { HOT_FOREX_SYMBOLS } from '@/constants/configs/hot-forex';

export const getChartsHistories = async () => {
  try {
    const results = await Promise.allSettled(
      HOT_FOREX_SYMBOLS.map(symbol => GETv1HistoryBySymbol({ symbol, quote: 1 }))
    );

    return results
      .filter((val): val is PromiseFulfilledResult<any> => val.status === 'fulfilled')
      .map(val => val.value);
  } catch (e) {
    console.error('[getChartsHistories API錯誤]', e);

    return [];
  }
};
